import Logo from './logo.png';

export const logo = Logo;
